import React, { useState } from "react";
import { API, graphqlOperation, Auth } from "aws-amplify";
import RequestTickerAlert from "./RequestTickerAlert";
import Loading from "_shared/components/Loading/Loading";
import { customModalStyles } from "_shared/components/Modal/ModalStyles";
import Modal from "react-modal";
import "./table/KissViewAndTicker.scss";

const TickerSearchbar = (props) => {
  const [search, setSearch] = useState("");
  const [results, setResults] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [ticker, setTicker] = useState("");
  const [name, setName] = useState("");
  const [modalIsOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState("test@example.com");
  const [message, setMessage] = useState("");
  const [tickerSymbolInputEmpty, setTickerSymbolInputEmpty] =
    React.useState(false);
  const [subject, setSubject] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [tickerList, setTickerList] = useState([]);

  const ref = React.useRef();

  React.useEffect(() => {
    const getUserAndTickerData = async () => {
      const userData = (await Auth.currentSession()).getIdToken().payload;
      const tickerList = await API.graphql(
        graphqlOperation(
          `{
              ticker(where: {panel: {longbow_panel: {_eq: false}}}) {
                ticker
              }
            }`,
        ),
      );
      setEmail(userData.email);
      setTickerList(tickerList.data.ticker);
    };
    getUserAndTickerData();
  }, []);
  const addTicker = (obj) => {
    if (!obj.exists) return;
    //add ticker to selected list
    setResults([""]);
    setSearch("");
    //if ticker is already added to the list, don't add it again
    for (let i = 0; i < props.selectedTickerList.length; i++)
      if (props.selectedTickerList[i] === obj.ticker) return;
    if (props.tickersRemaining > 0) {
      props.setSelectedTickerList([...props.selectedTickerList, obj.ticker]);
      //checks if the ticker has been added to any other tabs, if so don't decrement tickersRemaining
      for (let i = 0; i < tickerList.length; i++)
        if (tickerList[i].ticker === obj.ticker) return;
      props.setTickersRemaining(props.tickersRemaining - 1);
    }
  };

  function closeModal() {
    setSuccess(false);
    setIsOpen(false);
    setLoading(true);
    setTickerSymbolInputEmpty(false);
  }

  async function submit() {
    if (subject.trim().length === 0) {
      setTickerSymbolInputEmpty(true);
      return;
    }

    //Get the user data
    const userData = (await Auth.currentSession()).getIdToken().payload;
    setEmail(userData.email);
    //Now we submit the message
    setLoading(true);
    await API.post("auth", "/cognito/zendesk", {
      body: {
        user: userData,
        subject: subject,
        message: message,
      },
    });
    setSuccess(true);
    setSubject("");
    setMessage("");
    setLoading(false);
  }

  return (
    <>
      <div ref={ref}>
        <div className="ticker-search-2">
          <input
            type="text"
            placeholder="Add Ticker"
            value={search}
            onChange={async (e) => {
              setSearch(e.target.value);

              if (e.target.value.length > 0) {
                const response1 = (
                  await API.graphql(
                    graphqlOperation(`{
                    search_tickers(where: {ticker: {_eq: "${e.target.value.toUpperCase()} US Equity"}}, limit: 1) {
                      ticker
                      name
                      exists
                      requested {
                        id
                      }
                    }
                  }`),
                  )
                ).data.search_tickers;

                const response2 = (
                  await API.graphql(
                    graphqlOperation(`{
                    search_tickers(where: {_and: [{ticker: {_nin: [${response1
                      .map((obj) => `"${obj.ticker}"`)
                      .join(",")}]}}, {_or: [{name: {_ilike: "${
                      e.target.value
                    }%"}}, {ticker: {_ilike: "${
                      e.target.value
                    }%"}}]}]}, limit: 5, order_by: {name: asc, exists: desc}) {
                      ticker
                      name
                      exists
                      requested {
                        id
                      }
                    }
                  }`),
                  )
                ).data.search_tickers;

                setResults([...response1, ...response2]);
              } else {
                setSearch("");
                setResults([]);
              }
            }}
          />
        </div>
        {results.length > 0 ? (
          <div
            style={{
              backgroundColor: "#2e2e2e",
              zIndex: 1,
              cursor: "pointer",
              maxHeight: 185,
              overflowY: results.filter((obj) => obj !== "").length
                ? "scroll"
                : "hidden",
            }}
          >
            {results
              .filter((obj) => obj !== "")
              .map((obj) => {
                return (
                  <div
                    key={obj.name}
                    className="ticker-list-container"
                    style={{ position: "relative" }}
                  >
                    <div
                      onClick={() => addTicker(obj)}
                      style={{
                        width: "100%",
                        display: "flex",
                        color: "#666666",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        textAlign: "left",
                        marginRight: 10,
                        cursor: !obj.exists ? "not-allowed" : "pointer",
                      }}
                    >
                      <div
                        style={{
                          textAlign: "left",
                          marginRight: 10,
                          color: !obj.exists ? null : "white",
                        }}
                      >
                        {obj.ticker}
                      </div>
                      <div className="ticker-name">
                        {obj.name.length > 26
                          ? obj.name.substring(0, 26) + "..."
                          : obj.name}
                      </div>
                    </div>
                    {!obj.exists ? (
                      !obj.requested ? (
                        <div
                          className="request-button"
                          onClick={(e) => {
                            setModalOpen(true);
                            setName(obj.name);
                            setTicker(obj.ticker);
                            setResults([]);
                            setSearch("");
                          }}
                        >
                          Request
                        </div>
                      ) : (
                        <div
                          className="request-button"
                          style={{
                            color: "#666666",
                            cursor: "not-allowed",
                            background: "transparent",
                          }}
                        >
                          Requested
                        </div>
                      )
                    ) : (
                      <div
                        onClick={() => addTicker(obj)}
                        style={{
                          color: obj.ticker ? "#98CD4B" : "transparent",
                          textAlign: "right",
                          cursor: props.selectedTickerList.includes(obj.ticker)
                            ? "not-allowed"
                            : "pointer",
                        }}
                      >
                        {props.selectedTickerList.includes(obj.ticker) ? (
                          <i className="fas fa-check-circle"></i>
                        ) : (
                          "+"
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                maxHeight: "110px",
                overflow: "auto",
              }}
            >
              {props.selectedTickerList
                .filter((obj) => obj !== "" || !obj)
                .map((ticker) => {
                  return (
                    <div key={ticker}>
                      <div
                        onClick={(e) => {
                          props.setSelectedTickerList(
                            props.selectedTickerList.filter(
                              (obj) => obj !== e.target.id,
                            ),
                          );
                          setResults([""]);
                          setSearch("");
                          for (let i = 0; i < tickerList.length; i++)
                            if (tickerList[i].ticker === ticker) return;
                          props.setTickersRemaining(props.tickersRemaining + 1);
                        }}
                        className="ticker-bubble"
                        id={ticker}
                      >
                        {ticker}
                        <span className="ticker-bubble-x" id={ticker}>
                          x
                        </span>
                      </div>
                    </div>
                  );
                })}
            </div>
            {search !== "" && (
              <div style={{ display: "block" }}>
                <p
                  style={{
                    color: "#666",
                    padding: "10px 0px 10px 70px",
                    fontSize: "12px",
                    fontStyle: "italic",
                    fontWeight: "bold",
                    letterSpacing: 0.5,
                  }}
                  onClick={(e) => {
                    setIsOpen(true);
                    setLoading(false);
                    setSearch("");
                    setResults([]);
                  }}
                >
                  Don't see it on this list?
                  <span style={{ color: "#75CE41", fontStyle: "italic" }}>
                    &nbsp;&nbsp;Email us
                  </span>
                </p>
              </div>
            )}
          </div>
        ) : search !== "" ? (
          <div
            style={{
              position: "absolute",
              backgroundColor: "#2e2e2e",
              zIndex: 4,
              width: 345,
              cursor: "pointer",
              marginTop: 2,
            }}
          >
            <p
              style={{
                color: "#666",
                padding: "10px 0px 10px 70px",
                fontSize: "12px",
                fontStyle: "italic",
                fontWeight: "bold",
                letterSpacing: 0.5,
              }}
              onClick={(e) => {
                setIsOpen(true);
                setLoading(false);
                setSearch("");
                setResults([]);
              }}
            >
              Don't see it on this list?
              <span style={{ color: "#75CE41", fontStyle: "italic" }}>
                &nbsp;&nbsp;Email us
              </span>
            </p>
          </div>
        ) : (
          <div></div>
        )}
      </div>
      <Modal
        isOpen={modalIsOpen}
        // onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customModalStyles}
        contentLabel="Example Modal"
      >
        {!success ? (
          <div className="help-modal">
            <div className="modal-header">
              <h2 className="header-title">Request Unlisted Ticker</h2>
              <i onClick={closeModal} className="fas fa-times"></i>
            </div>
            {loading ? (
              <Loading variant="modal" />
            ) : (
              <div className="modal-content">
                <div className="header-text">
                  Don't see a ticker available to add or request? Open a ticket
                  and we'll look into it.
                </div>

                <form>
                  <div className="subject-text">Ticker Symbol</div>
                  <input
                    style={{}}
                    value={subject}
                    onChange={(e) => {
                      setSubject(e.target.value);
                    }}
                    className="subject-input"
                  />
                  {tickerSymbolInputEmpty ? (
                    <div
                      style={{
                        color: "#d33541",
                        position: "relative",
                        top: -10,
                      }}
                    >
                      Must include a Ticker Symbol
                    </div>
                  ) : null}
                  <div className="subject-text">
                    Anything to add about this request?
                  </div>
                  <textarea
                    value={message}
                    onChange={(e) => {
                      setMessage(e.target.value);
                    }}
                    className="help-input"
                  />
                </form>
                <div className="buttons">
                  <div onClick={submit} className="button-send">
                    Send
                  </div>
                  <div onClick={closeModal} className="button-cancel">
                    Cancel
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="help-modal">
            <div className="modal-header">
              <i onClick={closeModal} className="fas fa-times"></i>
            </div>
            <div className="modal-content-thank-you">
              <i className="header-icon-thank-you justify-center envelope-icon far fa-envelope"></i>
              <div className="header-text-thank-you">Message received.</div>
              <div className="body-text-thank-you">
                We've received your message and have sent you a confirmation
                email to <div className="email">{email}</div>. Someone from our
                team will follow up with you within the next 48 hours.
              </div>
            </div>
          </div>
        )}
      </Modal>
      {modalOpen ? (
        <RequestTickerAlert
          setModalOpen={setModalOpen}
          modalOpen={modalOpen}
          ticker={ticker}
          name={name}
        />
      ) : null}
    </>
  );
};

export default React.memo(TickerSearchbar);
